<template>
<div class="chapter">
<div class="inner_page">
<p class="center"><a id="page9"></a><em>DEDICATED TO<br/>Professor Alexander Lerner, two of whose daughters, aged five and three, were killed by the Nazis in 1941, and whose own sixteen-year struggle to leave the Soviet Union for Israel is now successfully concluded</em></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ded.vue?b72878de